// Tiny store that records the route the user was on JUST BEFORE
// they opened a cinematic player (media / live-tv-player /
// torbox-play / youtube-play). The player's back button reads
// from here instead of riding browser history -- intermediate
// pushes (resume overlay, channel-prev/next via router.replace,
// route-guard redirects) keep dragging history.back() to the
// wrong place, especially in TV mode.
//
// Set by router/index.js beforeEach; read by each player's goBack().

import { defineStore } from 'pinia'

const CINEMATIC_ROUTES = new Set([
  'media',
  'live-tv-player',
  'torbox-play',
  'youtube-play',
])

export function isCinematicRoute(name) {
  return typeof name === 'string' && CINEMATIC_ROUTES.has(name)
}

export const useNavStore = defineStore('nav', {
  state: () => ({
    // Map of cinematic route name -> fullPath the user came from.
    // Read by goBack() so we land on the exact origin.
    returnRoutes: {},
  }),
  actions: {
    rememberReturn(toName, fromFullPath) {
      if (!isCinematicRoute(toName)) return
      if (!fromFullPath || fromFullPath === '/') return
      // Don't overwrite if the source itself is a cinematic route --
      // that just means the user moved between players (e.g. live-tv
      // next-channel). The original entry route is still the right
      // back target.
      this.returnRoutes[toName] = fromFullPath
    },
    // Read-only -- intermediate navigations or follow-up modals would
    // otherwise consume the entry and break a second back attempt.
    // We let next entry to the route overwrite the stored value.
    getReturn(toName) {
      return this.returnRoutes[toName] || null
    },
  },
})
